<template>
  <div class="f-col full">
    <template v-if="target">
      <iframe class="full" :src="target" frameborder="0" ref="hydra-editor"></iframe>
    </template>
    <template v-else>
      <div class="f-row ctr full">
        <span class="error-message">Não foi possível abrir o editor</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Sandbox",
  computed: {
    target() {
      const actual = this.$store.state.editor.actual;
      const url = this.$store.state.editor.sites[actual]?.domain;
      const token = this.$store.state.auth.token;
      if (!token || !url) return null;
      else return `https://${url}/?token=${token}`;
    }
  },
  beforeCreate() {
    if (this.$store.state.editor.actual === null)
      this.$router.push({ name: "editor" }).catch(() => {});
  },
  created() {
    this.$store.commit("TOGGLE_DISPLAY_LAYOUT", {
      menu: false,
      header: true,
      footer: true
    });
    this.$store.commit("SWITCH_EDITOR_LAYOUT", {
      headerMode: "editor",
      footerMode: "editor"
    });
  },
  beforeDestroy() {
    this.$store.commit("CHANGE_SANDBOX", { actual: null });
    this.$store.commit("SWITCH_EDITOR_LAYOUT", {
      headerMode: "default",
      footerMode: "default"
    });
  }
};
</script>

<style scoped>
.error-message {
  margin: 0 10px 58px;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  color: #444;
}
</style>